import {
  ChangeDetectionStrategy,
  Component,
  model,
  signal,
} from '@angular/core';
import { InventoryTemplateComponent } from '@core/components/inventory-template/inventory-template.component';
import { Skin } from '@core/interfaces/skin.interface';
import { sleep } from '@core/utils/sleep.util';
import { KingType } from '@features/games/king/types/king.type';
import { ModalService } from '@core/modals/services/modal.service';
import { KingService } from '@features/games/king/king.service';
import { SvgIconComponent } from 'angular-svg-icon';
import { NgpTooltip, NgpTooltipTrigger } from 'ng-primitives/tooltip';

@Component({
  selector: 'app-deposit-king-modal',
  imports: [
    InventoryTemplateComponent,
    SvgIconComponent,
    NgpTooltip,
    NgpTooltipTrigger,
  ],
  templateUrl: './deposit-king-modal.component.html',
  styleUrl: './deposit-king-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class DepositKingModalComponent {
  readonly type = signal<KingType>('vault');
  readonly selectedSkins = model<Skin[]>([]);
  readonly isProcessing = signal(false);

  constructor(
    private kingService: KingService,
    private modalService: ModalService
  ) {}

  public async joinKing() {
    this.isProcessing.set(true);
    try {
      const trade = await this.kingService.joinKing(
        this.selectedSkins(),
        this.type()
      );

      this.modalService.openModal('TradeModal', {
        tradeModalOptions: {
          trade_offer_id: trade.offerid,
          trade_hash: trade.hash,
          trade_skins: this.selectedSkins(),
          typography_trade_for: 'join the king',
        },
        balance: 'skins',
      });
      this.modalService.closeModals(['DepositKingModal']);
    } catch {
    } finally {
      this.isProcessing.set(false);
    }
  }

  toggleType() {
    this.type.update((type) => (type === 'fight' ? 'vault' : 'fight'));
  }
}
